/* eslint-disable @typescript-eslint/no-explicit-any */
import { v4 } from 'uuid';

import { blueprintData8 } from '../defaults';
import { deepCopy } from '../../helpers';
import { updateKitchens } from './update.8/update-kitchens';
import { BlueprintData7, BlueprintData8 } from '../types';

export const u8 = (blueprint: BlueprintData7): BlueprintData8 | null => {
	console.log('schema-update:process-update:8:started');

	try {
		const bpd: BlueprintData8 = {
			...deepCopy(blueprintData8),
			id: blueprint.id ?? v4(),
			schemaVersion: 8,
			email: blueprint.email,
			submissionDate: blueprint.submissionDate,
			submissionId: blueprint.submissionId,
			thumbnail: blueprint.thumbnail,
			metadata: blueprint.metadata,
			kitchens: updateKitchens(blueprint.kitchens)
		};

		console.log('schema-update:process-update:8:completed', bpd);
		return bpd;
	} catch (err) {
		console.error(err);
	}

	console.log('schema-update:process-update:8:failed');
	return null;
};
